export enum OperatingSystemListEvents {
  OPERATING_SYSTEM_SELECTION_CHANGED = 'operatingSystemsChanged',
}
